export const Logo = ({ size = 32 }) => (
  <img
    src="/fev-logo.png"
    width={size}
    height={size}
    alt="Future Energy Venture"
    style={{ display: "block", objectFit: "contain" }}
  />
);
